import { gql } from '@apollo/client'
import { CrowdPad } from '@appTypes/CrowdPadTypes'

export interface CrowdPadByIdVars {
  id: string
  chainId: number
}

export interface CrowdPadByIdData {
  crowdPad: CrowdPad
}

export const CROWDPAD_BY_ID_QUERY = gql`
  query GetCollectivePurchaseById($id: String!, $chainId: Int!) {
    crowdPad(id: $id, chainId: $chainId) {
      amount
      buyersCount
      chainId
      cutoff
      extra
      extension
      fee
      fractions
      fractionsCount
      id
      limitPrice
      name
      paymentToken {
        symbol
        name
        decimals
        id
      }
      timestamp
      symbol
      status
      seller
      reservePrice
      target {
        metadata {
          description
          image
          animationType
          animation_url
          asset_contract {
            name
            schema_name
          }
          attributes {
            value
            trait_type
          }
          author
          discord
          imageFull
          instagram
          name
          owner
          properties {
            total_supply {
              type
              description
            }
            preview_media_file_type2 {
              type
              description
            }
            preview_media_file_type {
              type
              description
            }
            preview_media_file2_type {
              type
              description
            }
            preview_media_file2 {
              type
              description
            }
            preview_media_file {
              type
              description
            }
            name {
              type
              description
            }
            description {
              type
              description
            }
            created_at {
              type
              description
            }
          }
          social_media
          telegram
          totalSupply
          twitter
          web_site_url
        }
        chainId
        boxItemCount
        collection {
          symbol
          name
          id
        }
        contract_type
        id
        tokenId
        tokenURI
      }
      buyers {
        ownership
        fractionsCount
        buyer
        amount
      }
    }
  }
`
